import React from 'react';
import {
  Form,
  Select,
  Button,
  Collapse,
  Modal ,
  DatePicker, 
  InputNumber,
} from 'antd';
import {SearchOutlined  } from '@ant-design/icons';
import {connect} from "react-redux";
import BASE_URL_Majid from '../../BASE_URL_Majid';
import axios from 'axios';
import {PeropertyHotel_State_Action} from '../../action/ListPeropertyAction';
import { Redirect } from 'react-router-dom';
import Loader from './Loader';
import moment from 'moment';



class HotelSearch extends React.Component {

  state = {
    redirect : false ,
    visible : false ,
    display : false ,
  }

  handleOk = ()=> {
    this.setState({visible:false});
  }

  


  onFinish = (values)=> {
    sessionStorage.setItem("hotelDateStart", moment(values.date[0]['_d']).format('YYYY-MM-DD'));
    sessionStorage.setItem("hotelDateEnd", moment(values.date[1]['_d']).format('YYYY-MM-DD'));
    this.setState({display:true})
    const postdata = {
      "start_time":moment(values.date[0]['_d']).format('YYYY-MM-DD'),
      "end_time":moment(values.date[1]['_d']).format('YYYY-MM-DD'),
      "city": values.city ? values.city : "",
      "bed_count":values.quantity ? values.quantity : "" ,
      "level":[],
      "cafe":"",
      "restaurant":""
    };
    axios.post(BASE_URL_Majid +  `/hotels/search_hotel` , postdata)
      .then((res) => {
        if(res.data.result === "ok"){
          this.props.PeropertyHotel_State_Action(res.data.data);
          this.setState({
            redirect:true,
            display:false ,
          })
        } 
        else if(res.data.result === "error"){
          this.setState({
            visible : true,
            display:false ,
          })
        }
      })
      .catch((err)=>{
        this.setState({process : false})
        alert("Network Error")
        console.log(err);
      })
  }


  render() {
    const { Panel } = Collapse;
    const { RangePicker } = DatePicker;
    return (
    <>  
      { this.state.redirect ? (<Redirect  to='listhotel'  />) : null }
      { this.state.display == true ? <Loader/> : null}
      <Form
        layout="filter"
        id="filter-form"
        onFinish={this.onFinish}
      >
        <Form.Item name="city" >
          <Select placeholder="City">
              <Select.Option value="Dubai">Dubai</Select.Option>
              <Select.Option value="Abu Dhabi">Abu Dhabi</Select.Option>
              <Select.Option value="Sharjah">Sharjah</Select.Option>
              <Select.Option value="Al Ain">Al Ain</Select.Option>
              <Select.Option value="Ajman">Ajman</Select.Option>
              <Select.Option value="RAK City">RAK City</Select.Option>
              <Select.Option value="Fujairah">Fujairah</Select.Option>
              <Select.Option value="Umm al-Quwain">Umm al-Quwain</Select.Option>
              <Select.Option value="Khor Fakkan">Khor Fakkan</Select.Option>
              <Select.Option value="Kalba">Kalba</Select.Option>
              <Select.Option value="Jebel Ali">Jebel Ali</Select.Option>
              <Select.Option value="Dibba Al-Fujairah">Dibba Al-Fujairah</Select.Option>
              <Select.Option value="Madinat Zayed">Madinat Zayed</Select.Option>
              <Select.Option value="Ruwais">Ruwais</Select.Option>
              <Select.Option value="Liwa Oasis">Liwa Oasis</Select.Option>
              <Select.Option value="Dhaid">Dhaid</Select.Option>
              <Select.Option value="Ghayathi">Ghayathi</Select.Option>
              <Select.Option value="Ar-Rams">Ar-Rams</Select.Option>
              <Select.Option value="Dibba Al-Hisn"> 	Dibba Al-Hisn</Select.Option>
              <Select.Option value="Hatta">Hatta</Select.Option>
              <Select.Option value="Al Madam">Al Madam</Select.Option>
          </Select>
        </Form.Item>  
        <Form.Item name="quantity" >
          <InputNumber  placeholder="BedRoom"/>
        </Form.Item> 
        <Form.Item name="date" rules={[{ required: true}]} >
          <RangePicker/>
        </Form.Item>
        <Form.Item className="form-filter-submit">
          <Button htmlType="submit"><SearchOutlined/>Search</Button>
        </Form.Item>
      {/* <button onClick={()=>{console.log(this.props.Displaylistdata)}}> fwef</button> */}
      </Form>
      <Modal  visible={this.state.visible} onCancel={this.handleOk} footer={null}>
        <p>Data Not Found</p>
      </Modal>
    </>  
    );
  }
}

const mapStateToProps = state => {

  return({
    Displaylistdata: state.listhoteldata,
  })
}
const mapDispatchToProps = {PeropertyHotel_State_Action};

export default connect(mapStateToProps,  mapDispatchToProps )(HotelSearch);

